import { TagBox } from "devextreme-react";
import { Form, GroupItem, Label, SimpleItem } from "devextreme-react/form";
import { forwardRef, useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FileUploader } from "../../components";
import { getApiParams } from "../../redux/auth";
import { BodyType, createRequest } from "../../redux/base/request";
import { ApiResponse, verfiyResponse } from "../../redux/base/types/saga";
import { getLocalized } from "../../redux/localization";
import { textEditorOptions } from "../../utils/helpers";
import { Category } from "../account/detail/tabs/product/type";
import HTMLEditor from "./HTMLEditor";
import { UpdateBlog } from "./type";


const EditBlogform = forwardRef<any, { data: UpdateBlog }>((
    { data }, ref
) => {
    const localize = useSelector(getLocalized);
    const { token, lang } = useSelector(getApiParams);
    const [categories, setCategories] = useState<Category[]>([]);
    const getCategories = useCallback((async () => {
        const response: ApiResponse<Category[]> = await createRequest({
            method: "GET",
            url: "/api/dashboardview/categories",
            bodyType: BodyType.formdata,
            token,
            body: {},
            lang,
        });
        if (verfiyResponse(response)) {
            setCategories(response.Result)
        }
    }), [token, lang])




    useEffect(() => {
        getCategories()
    }, [getCategories])
    let tags: any = [];
    const customCreateTag = (args: any) => {
        const newValue = args.text
        args.customItem = newValue
        if (newValue) {
            tags.push(...data.BlogTags, newValue)
            data.BlogTags = tags
        } else {
            // eslint-disable-next-line no-self-assign
            data.BlogTags = data.BlogTags
        }
    }
    useEffect(() => {
        data.BlogTags = data.BlogTags?.filter((item: any) => item !== "" || item.Name !== null)
        console.log(data, "edit")
    }, [data])
    return <Form
        formData={data}
        ref={ref}
    >
        <GroupItem>
            <SimpleItem
                dataField={`ProductCategoryId`}
                label={{
                    text: localize.getString("category"),
                }}
                editorType={"dxLookup"}
                editorOptions={
                    {
                        searchEnabled: true,
                        items: categories,
                        displayExpr: "Name",
                        valueExpr: "Id",
                    }
                }
            >
            </SimpleItem>
            <SimpleItem
                dataField="Name"
                label={{
                    text: localize.getString("name")
                }}
                editorType={"dxTextBox"}
                editorOptions={{
                    inputAttr: {
                        style: " text-transform: capitalize",
                    },
                }}
            />
            <SimpleItem
                dataField="ShortContent"

                label={{
                    text: localize.getString("shortContent")
                }}
                render={(e: any) => (
                    <HTMLEditor data={data} height="200px"/>
                )}

            />
            <SimpleItem
                dataField="Content"
                label={{
                    text: localize.getString("content")
                }}
                editorType={"dxHtmlEditor"}
                editorOptions={textEditorOptions}
            />




            <GroupItem colCount={2}>

                <SimpleItem
                    dataField={"BlogTags"}
                    label={{
                        text: localize.getString("blogTag")
                    }}
                    render={(e: any) => {
                        return <TagBox
                            items={data.BlogTags}
                            acceptCustomValue={true}
                            defaultValue={data.BlogTags}
                            onCustomItemCreating={customCreateTag}
                            onValueChanged={(e: any) => {
                                data.BlogTags = e.value

                            }}

                        >
                        </TagBox>

                    }}
                >

                </SimpleItem>
                <SimpleItem
                    dataField="Image"
                >
                    <FileUploader
                        buttonText={localize.getString("selectFile")}
                        onValueChanged={(values) => {
                            data.Image = values[0]
                        }}
                    />
                    <Label text={localize.getString("image")}></Label>
                </SimpleItem>


            </GroupItem>

        </GroupItem>
    </Form >
})

export default EditBlogform;